import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, message } from 'antd';
import {
  DashboardOutlined,
  SettingOutlined,
  DatabaseOutlined,
  GlobalOutlined,
  BarChartOutlined,
  LoginOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Scripts from './components/Scripts';
import Domains from './components/Domains';
import Statistics from './components/Statistics';
import System from './components/System';
import SubstituteConfigs from './components/SubstituteConfigs';
import api from './services/api';

const { Header, Sider, Content } = Layout;

function App() {
  const [collapsed, setCollapsed] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedKey, setSelectedKey] = useState('dashboard');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 检查是否已登录
    const token = localStorage.getItem('token');
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  // 监听路由变化，更新选中的菜单项
  useEffect(() => {
    const path = location.pathname;
    const key = path.substring(1); // 移除前面的 /
    if (key && ['dashboard', 'scripts', 'domains', 'substitute-configs', 'statistics', 'system'].includes(key)) {
      setSelectedKey(key);
    }
  }, [location.pathname]);

  const handleLogin = (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setIsAuthenticated(true);
    message.success('登录成功');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete api.defaults.headers.common['Authorization'];
    setIsAuthenticated(false);
    message.success('已退出登录');
  };

  const menuItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: '概览',
    },
    {
      key: 'scripts',
      icon: <DatabaseOutlined />,
      label: '脚本管理',
    },
    {
      key: 'domains',
      icon: <GlobalOutlined />,
      label: '域名规则',
    },
    {
      key: 'substitute-configs',
      icon: <FileTextOutlined />,
      label: '替代配置',
    },
    {
      key: 'statistics',
      icon: <BarChartOutlined />,
      label: '统计分析',
    },
    {
      key: 'system',
      icon: <SettingOutlined />,
      label: '系统管理',
    },
  ];

  const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
      handleLogout();
    } else {
      // 导航到对应的路由
      setSelectedKey(key);
      navigate(`/${key}`);
    }
  };

  if (loading) {
    return <div>加载中...</div>;
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <div className="logo" style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <h2 style={{ color: 'white', margin: 0 }}>{collapsed ? 'M' : '管理系统'}</h2>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0 }}>后台管理</h3>
          <Menu
            mode="horizontal"
            items={[{
              key: 'logout',
              icon: <LoginOutlined />,
              label: '退出登录',
            }]}
            onClick={handleMenuClick}
            style={{ borderBottom: 'none' }}
          />
        </Header>
        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff' }}>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/scripts" element={<Scripts />} />
            <Route path="/domains" element={<Domains />} />
            <Route path="/substitute-configs" element={<SubstituteConfigs />} />
            <Route path="/statistics" element={<Statistics />} />
            <Route path="/system" element={<System />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

export default App;
